export class GdsgInventoryReportCsvOptions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "delimiter",
            "baseName": "delimiter",
            "type": "string",
            "format": ""
        },
        {
            "name": "recordSeparator",
            "baseName": "recordSeparator",
            "type": "GdsgInventoryReportCsvRecordSeparator",
            "format": ""
        },
        {
            "name": "headerRequired",
            "baseName": "headerRequired",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GdsgInventoryReportCsvOptions.attributeTypeMap;
    }
    constructor() {
    }
}
